<template>
  <div>
    <v-dialog
      eager
      v-model="dialog"
      persistent
      max-width="600"
      transition="scroll-y-transition"
    >
      <v-card>
        <v-toolbar flat class="white--text orange darken-3">
          <v-toolbar-title>Sblocca asta</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn depressed class="white--text" light icon @click="dismiss">
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <div class="pa-4">
            <div class="text-left">
              Stai usando la versione <b>free</b> di Asta Live:
              <br />
              Puoi assegnare/mettere all'asta fino a
              <b>{{ Constants.NUM_ASSEGNAZIONI_FREE }}</b> calciatori.
              <br />
              Hai ancora a disposizione
              <b>{{ asta_info.counter }}</b> assegnazioni.
              <br />
              Clicca subito su "Vai all'acquisto" per rimuovere tale limite
              <strong>in questa asta</strong>.
            </div>

            <div class="text-center my-4">
              <v-btn
                rounded
                large
                class="orange white--text"
                v-if="!premium"
                @click="gotoPagamento"
                ><v-icon class="mr-2">verified</v-icon>
                <div>
                  VAI ALL'ACQUISTO
                  <br />
                  <small class="orange--text text--lighten-3">{{ asta_info.lega.maxSquadre }} squadre</small>
                </div>
                <v-icon class="ml-2">verified</v-icon>
              </v-btn>

              <!-- <a
                class="v-btn v-btn--rounded v-size--large v-btn--is-elevated orange white--text my-4"
                v-if="!premium"
                :href="Config.HOST + '/asta-live/sblocca/' + asta_info.id"
                target="_blank"
              >
                <v-icon left class="white--text">verified</v-icon>
                VAI ALL'ACQUISTO
                <v-icon right class="white--text">verified</v-icon>
              </a> -->
            </div>

            <div class="text-left">
              * Asta Live viene
              <strong class="error--text">pagata da una sola persona</strong>
              e <strong class="error--text">si sblocca per tutti</strong> i
              componenti dell'asta!
              <!-- <br /><br />
              ** Numero indicativo della quota che ciascun membro della lega
              dovrebbe dare alla persona che ha pagato -->
            </div>

            <div class="text-center mt-2 font-hemi-head">TABELLA PREZZI</div>

            <tabella-prezzi :maxSquadre="asta_info.lega.maxSquadre"></tabella-prezzi>

            <div class="text-right mt-5 mr-2">
              <v-btn
                depressed
                rounded
                outlined
                v-if="!premium"
                @click="voucherDialog = true"
              >
                Hai un voucher?
              </v-btn>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-dialog v-model="voucherDialog" max-width="600px">
      <v-form ref="form" @submit.prevent="submit">
        <v-card>
          <v-card-title> Hai un Voucher? </v-card-title>
          <v-card-text>
            <v-text-field
              placeholder="Inseriscilo qui*"
              required
              v-model="voucherInput"
              @input="$v.voucherInput.$touch()"
              :error-messages="voucherInputErrors"
            ></v-text-field>
            <!-- <v-text-field label="Inseriscilo qui*" required v-model="voucherInput"></v-text-field> -->
          </v-card-text>

          <v-card-actions class="pb-5 pr-4">
            <v-spacer></v-spacer>
            <v-btn
              color="grey"
              text
              rounded
              large
              @click="voucherDialog = false"
            >
              Annulla
            </v-btn>
            <v-btn
              color="primary"
              rounded
              large
              @click="submitVoucher"
              :disabled="this.$v.$invalid"
            >
              Invia
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>
import db from "../../js/db";
import Constants from "../../js/constants";
import * as Helpers from "../../js/helpers";
import Config from "../../../config-app/config";

import mixins from "../../js/mixins";
import TabellaPrezzi from "../common/TabellaPrezzi";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";

export default {
  mixins: [mixins, validationMixin],
  components: { TabellaPrezzi },
  validations: {
    voucherInput: { required },
  },
  data() {
    return {
      dialog: false,
      voucherDialog: false,
      voucherInput: "",
    };
  },
  computed: {
    voucherInputErrors() {
      let errors = [];
      if (!this.$v.voucherInput.$dirty) return errors;
      !this.$v.voucherInput.required &&
        errors.push('Campo "Voucher" obbligatorio.');
      return errors;
    },
  },
  mounted() {
    console.log("--> AstaSblocca mounted.");
    db.on("showSblocco", this.show);
  },
  destroyed() {
    console.log("<-- AstaSblocca destroyed.");
    db.off("showSblocco", this.show);
  },
  methods: {
    gotoPagamento() {
      this.$router.push({
        name: "pagamento",
        params: { asta_id: this.asta_id },
      });
    },
    selezionato(num) {
      return {
        selezionato:
          this.asta_info.lega.maxSquadre == num ||
          (num == 12 && this.asta_info.lega.maxSquadre >= 12),
      };
    },
    show() {
      this.dialog = true;
    },
    dismiss() {
      this.dialog = false;
    },
    submitVoucher() {
      // runna tutti i check sui campi del form
      this.$v.$touch();

      if (this.$v.$invalid) {
        return;
      }

      let params = {
        params: {
          uid: this.user_claims.fp_uid,
          sessid: this.user_claims.fp_sessid,
          os: this.user_claims.os,
          token: Config.API_TOKEN,
          ID_Lega: this.asta_info.id,
          voucher: this.voucherInput,
        },
      };
      this.$Progress.start();
      this.$http
        .get(Config.API_ENDPOINT + "/validate_voucher.php", params)
        .then((response) => {
          // Success.
          this.$Progress.finish();
          let json = response.body;
          if (json.status === 1) {
            Swal.fire({
              icon: "success",
              text: json.msg,
            });
            this.voucherDialog = false;
            this.dialog = false;
          } else {
            Swal.fire({
              icon: "error",
              text: json.msg,
            });
          }
        })
        .catch((err) => {
          // Failed.
          this.$Progress.fail();
          Swal.fire({
            icon: "error",
            text: "Errore inaspettato. Riprova",
          });
        });
    },
  },
};
</script>
